// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1mw9R","item":"PaymentsMobile_item__iAYPe","label":"PaymentsMobile_label__7MeBp","amount":"PaymentsMobile_amount__31bNo"};